import React from 'react';
import ReactDOM from 'react-dom/client';

// A second business's deployment (REACT_APP_MODULES set by scripts/tenant-build.js) mounts
// TenantApp instead. The test is a build-time constant on their build, so webpack drops
// App and the whole Hollypaul engine from their bundle; our build is unchanged.
const App = process.env.REACT_APP_MODULES
  ? require('./tenant/TenantApp').default
  : require('./App').default;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
